import { render } from "./ClientDbMaintenance.vue?vue&type=template&id=7ba0b2b5&scoped=true"
import script from "./ClientDbMaintenance.vue?vue&type=script&lang=js"
export * from "./ClientDbMaintenance.vue?vue&type=script&lang=js"

import "./ClientDbMaintenance.vue?vue&type=style&index=0&id=7ba0b2b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba0b2b5"]])

export default __exports__